import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import HotsheetForm from './Form'

@inject('websites', 'hotsheets')
@observer
export default class EditHotsheet extends Component {
  website = this.props.websites.current

  handleData = data => {
    const { hotsheet } = this.state
    return this.props.hotsheets.update({ id:hotsheet.id, ...data }).then(() => {
      this.props.router.push(`/website/${this.website.id}/hotsheets`)
    })
  }

  constructor(...args) {
    super(...args)

    const hotsheet = this.getHotsheet()
    if (hotsheet) {
      this.state = { hotsheet }
    } else {
      this.state = {}
      this.props.hotsheets.load(this.props.params.hotsheetId).then(() => {
        const hotsheet = this.getHotsheet()
        this.setState({ hotsheet })
      })
    }
  }

  getHotsheet() {
    const { hotsheets, params: { hotsheetId } } = this.props
    return hotsheets.findById(hotsheetId)
  }

  renderLoading() {
    return (
      <div className="loading">Loading...</div>
    )
  }

  getDefaults() {
    const { hotsheet } = this.state
    const { state={}, query } = this.props.location
    return { ...hotsheet, ...state, ...query }
  }

  render() {
    if (!this.state.hotsheet) return this.renderLoading()

    return (
      <div className="container centered padded hotsheets">
        <HotsheetForm
          defaults={this.getDefaults()}
          submit="Update Hotsheet"
          router={this.props.router}
          onData={this.handleData} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Hotsheets/Edit.js